import React, { useEffect, useRef, useState } from "react";
// import config from "../../../config";
import client from "../../../clients";
import { getAllMembers, getMemberByBranchPhone, getMemberCount } from "../helper/api";
import { isAuthenticated } from "../../../auth";
import { startLoader, stopLoader } from "../../../lib/utils";
import _, { throttle } from "lodash";
import { getTaxes } from "../../../core/helper/TaxApiCall";
import { transferMembership } from "../../memberships/helper/api";
import Toast from "../../../lib/toast";
import SearchFilter from "../../../components/search-filter";
import { getCustomers } from "../../../components/search-filter/helper/api";

const TransferMembershipModal = (props) => {

  const membership = props.membership;
  const transferTo = useRef(null); 
  const [hasMore,setHasMore] = useState(false);
  const [isButtonLock,setButtonLock] = useState(true);
  const [billingInfo, setBillingInfo] = useState({
    baseAmount:0,
    taxableAmount:0,
    subTotal: 0,
    surCharges: 0,
    taxBreakup: [],   // CGST, SGST, etc
    totalTax: 0,
    payableAmount: 0,
    remainingAmount: 0
  });
  const [taxes, setTaxes] = useState([]); // server taxes
  const [currentElementId, setCurrentElementId] = useState("");
  const [isTransferToListOpen, setTransferToListOpen] = useState(false);  
  const [transferAmount, setTransferAmount] = useState("");
  const [Surcharges, setSurcharges] = useState("");
  const [remark, setRemark] = useState("");
  const [Members,setMembers] = useState([]);
  const [pageSize,setPageSize] = useState(10);
  var [pageNo,setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [Total,setTotal] = useState(0);
  const {user,token} = isAuthenticated();
  const [searchKey,setSearchKey] = useState('');
  const [isMembersSpinnerLoader,setMembersSpinnerLoader] = useState(false);
  const [taxType,setTaxType] = useState('');
  const [paymentSources, setPaymentSources] = useState({
    online: ["NEFT", "RTGS", "IMPS", "UPI", "Credit Card", "Debit Card", "Juice"],
    wallet: ["Paytm", "PhonePe", "Google Pay", "Amazon Pay"]
  });
  const cardTypes = ["Visa", "Mastercard", "Zeta", "Rupay", "Amex", "Bajaj Finserv", "Tata Card"];
  const [invoiceDetails, setInvoiceDetails] = useState({
    paymentMode: "online",
    paymentSource: "",
    chequeNumber: "",
    bankName: "",
    upiId: "",
    comment: "",
    transactionID: "",
    cardType: "",
    approvedCode: "",
    paymentNumber: ""
  });
  const [newMember, setNewMember] = useState({
    name: "",
    phone: ""
  });
  const [isAddNewMember, setAddNewMember] = useState(false);
  const [isMemberExisting, setMemberExisting] = useState(true);
  const [isMemberExistingNote, setMemberExistingNote] = useState(false);
  const isMobile = window.innerWidth < 768;



   const handlePaymentMode = paymentMode => event =>{
    try{
      setInvoiceDetails(oldstate=>{

        oldstate.paymentMode = paymentMode;
        oldstate.paymentSource = "";
        oldstate.chequeNumber = "";
        oldstate.bankName = "";
        oldstate.upiId = "";
        oldstate.comment = "";
        oldstate.transactionID = "";

        return {
          ...oldstate
        }
      })
    }catch(error){
      
    }
  }

  const handleSelectPaymentSource = (source) => {
    setInvoiceDetails((oldState) => ({
      ...oldState,
      paymentSource: source
    }))
  }

  const handleSelectCard = (getCardType) => {
    setInvoiceDetails((oldState) => ({
      ...oldState,
      cardType: getCardType
    }))
  }



  const TransferMembership = async event =>{


    try{
      await startLoader()
      setButtonLock(true)
      const payload={
        mode:invoiceDetails.paymentMode,
        amountPaid:transferAmount,
        ...billingInfo,
        ...invoiceDetails,
        closed_by_role:user.role
      };

      if(transferTo?.current?.isEnquiry == true){
        payload.isEnquiry = "true";
        payload.enquiryId = transferTo?.current?._id;
        payload.existingUser = transferTo?.current?.userInfo
      } else{
        payload.isEnquiry = "false";
        payload.memberId = transferTo?.current?._id ? transferTo.current._id : "";
      }

      if(newMember.name && newMember.phone){
        payload.newMemberName = newMember.name;
        payload.newMemberPhone = newMember.phone;
      }
      
      const response = await transferMembership(user._id,token,membership._id,payload);

      console.log(response);

      if(response.error){
        new Toast({
          type:'error',
          duration:3000,
          message:response.error
        })
      }else{
        new Toast({
          type:'success',
          duration:3000,
          message:"Membership transfered successfully"
        });
        props.toggleFitnessTestModal("transfer-membership")
        props.reload();
      }
    }catch(error){

    }
    setButtonLock(false)
    await stopLoader();
  }


   const GetAllTaxes = async () =>{
      try{
        const branchId = localStorage.getItem("branchId");
        const params = {
          branchId,
          noLimit:'noLimit'
        };
        const responses = await getTaxes(user._id,token,params);
  
        if(!responses.error){
          setTaxes(responses);
        }
      }catch(error){
  
      }
    }

  const applyInclusive = () =>{
    if(taxType == "inclusive-tax") setTaxType("")
    else setTaxType("inclusive-tax")
  }


  const applyTaxes = event =>{
    if(taxType == "additional-tax") setTaxType("")
    else setTaxType('additional-tax');
  }

  const GetParam = () =>{
    let param = {
      pageNo,
      pageSize
    };
    if(searchKey) param.q = searchKey;
    param.branchId = localStorage.getItem("branchId");

    return param;
  }

  const GetAllMembers = async (isReload) =>{
    try{
      const param = GetParam();
      let response = await getCustomers(user._id,token,param);
      
      if(!response.error){

        await Promise.all(response.data.map(data=>{
          if(data.isEnquiry && !data?.user?.length){
            data.user = [
              {
                name:data?.userInfo?.name  || data?.userInfo?.full_name,
                phone:data?.userInfo?.phone,
                email:data?.userInfo?.name
              }
            ]
          }
        }))

        setMembers(isReload?response.data:[...Members,...response.data]);
        setHasMore(response?.pagination?.hasMore?true:false);
        setTotal(response.pagination.totalRecords)
      
      }
    }catch(error){

    }
  }

    // const GetMembersCount = async () => {
    //   try {
    //     let params = GetParam();
  
    //     delete params.pageNo;
    //     delete params.pageSize;
        
        
    //     let response = await getMemberCount(user._id, token, params);
        
    //     if(response.COUNT){
    //       pageNo = 1;

    //       setPageNo(pageNo)

    //       setPageCount(Math.ceil(response.COUNT / pageSize))

    //       setTotal(response.COUNT)

    //     }
    //   }catch (error) {
  
    //   }
    // }


    const handleMemberScroll = throttle(async (event) => {
      try {
        const { clientHeight, scrollTop, scrollHeight } = event.target;
        if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && hasMore && !isMembersSpinnerLoader) {
          pageNo = pageNo + 1;
          setPageNo(pageNo)
          
          setMembersSpinnerLoader(true);
          await GetAllMembers(false);
          setMembersSpinnerLoader(false)
        }
      } catch (error) {
        setMembersSpinnerLoader(false)
      }
    }, 800);

  const handleSelectTransferTo = (userInfo) => {
    transferTo.current=userInfo;
    // document.getElementById("transfer-to").value = userInfo.user[0].name;
  }

  const handleSearch = event =>{
    setSearchKey(event.target.value);
  }

  const toggleInputFields = (id) => event => {


    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
      if (event) {
        let interval = setInterval(() => {
          let element = event.target.querySelector('input');
          if (element) {
            element.focus();
            clearInterval(interval)
          }
        }, 0);
      }
    }

    if(id == "transfer-to"){
      
      // if(isTransferToListOpen && transferTo.current?.user?.[0]?.name) document.getElementById("transfer-to").value = transferTo.current?.user?.[0]?.name;
      // else document.getElementById("transfer-to").value = "";
      setTransferToListOpen(!isTransferToListOpen)
    }
  }

  // const handleChange = name => event => {
  //   if(name == 'transferAmount') setTransferAmount(event.target.value);
  //   else if(name == 'remark') setRemark(event.target.value);
  //   else setSurcharges(event.target.value);
  // }



  const handleChange = (name,value) => event => {

    if(name == 'transferAmount') setTransferAmount(event.target.value);
    else if(name == 'remark') setRemark(event.target.value);
    else if(name == 'Surcharges'){
      setSurcharges(event.target.value);
    }else if(name == 'member-phone'){
      setNewMember(prev => ({
        ...prev,
        phone: event.target.value
      }))
    }else if(name == 'member-name'){
      setNewMember(prev => ({
        ...prev,
        name: event.target.value
      }))
    }else{
      value = !value ? event.target.value : value; 
      setInvoiceDetails({
        ...invoiceDetails,
        [name]: value
      });
    }
  }

  const handleSearchingData = (searchedData) => {
    // setSearchKey(searchedData);
    setTimeout(() => {
      setSearchKey(searchedData);
    }, 700);
  }

  const toggleAddNewMember = () => {
    setAddNewMember(!isAddNewMember);
    
    if(isAddNewMember == true){
      //   setMemberExisting(true);
      // }else{
      transferTo.current = null
      setNewMember({
        name: "",
        phone: ""
      })
      setMemberExisting(true);
      setMemberExistingNote(false);
    }
  }

  const handleCheckExistingMember = async() => {

    if(newMember.phone && newMember.name){
      try{
        const params = {
          branchId: localStorage.getItem("branchId"),
          phone: newMember.phone
        };

        const isExistingMember = await getMemberByBranchPhone(user._id, token, params);

        console.log(isExistingMember);

        if(isExistingMember.data){
          setMemberExisting(true);
          setMemberExistingNote(true);
        }else{
          setMemberExisting(false);
          setMemberExistingNote(false);
        }

      }catch{

      }
    }else{
      new Toast({
        type:'error',
        duration:3000,
        message: "New Member Phone or Number Cannot be empty"
      })
    }
  }

  useEffect(async ()=>{
    try{
      await startLoader();
      GetAllTaxes();
    }catch(error){
      console.log(error)
    };
    await stopLoader()
  },[])


  useEffect(async ()=>{
    try{
      await startLoader();
      await GetAllMembers(true);
      await stopLoader();
    }catch(error){
      await stopLoader();
    }
  },[searchKey])




    useEffect(() => {
    if (!membership) return;
  
    const surchargePercent = Number(Surcharges ||
      0);
  
    // 1️⃣ Base Subtotal
    let baseAmount = Number(transferAmount || 0);
  
    // 2️⃣ Surcharge
    const surCharges = Number((baseAmount * surchargePercent) / 100);

  
    let taxBreakup = [];
    let totalTax = 0;
  
    if (taxType && taxes.length) {
      const totalTaxPercent = taxes.reduce(
        (sum, t) => parseFloat(parseFloat(sum) + (parseFloat(t.value) || 0)),
        0
      );
  
      if (taxType == "inclusive-tax") {
        // ✅ Extract tax from amount
        const inclusiveTax =
          (baseAmount * totalTaxPercent) /
          (100 + totalTaxPercent);
  
  
        totalTax = inclusiveTax;
  
        taxBreakup = taxes.map(tax => {
          const amount =
            (inclusiveTax * tax.value) / totalTaxPercent;
  
          return {
            ...tax,
            amount: amount.toFixed(2)
          };
        });
      } else if(taxType == "additional-tax") {
        // ✅ Exclusive tax (normal add-on)
        taxBreakup = taxes.map(tax => {
          const amount =
            (baseAmount * tax.value) / 100;
          totalTax += amount;
  
          return {
            ...tax,
            amount: amount.toFixed(2)
          };
        });
      }
    }
  
    const taxableAmount = taxType == "inclusive-tax"
      ? baseAmount - totalTax
      : baseAmount;
  
    const subTotal = taxType != "additional-tax"
      ? baseAmount
      : baseAmount + totalTax;
  
    // 3️⃣ Payable
    const payableAmount =
      subTotal + surCharges;
  
    setBillingInfo(prev => ({
      ...prev,
      taxBreakup,
      baseAmount,
      taxableAmount: Math.round(taxableAmount),
      subTotal: Math.round(subTotal),
      surCharges: Math.round(surCharges),
      payableAmount: Math.round(payableAmount)
    }));
  
  }, [transferAmount,taxType, taxes,Surcharges]);

  useEffect(()=>{
    if(transferAmount && newMember.name && newMember.phone){
      setButtonLock(false);
    }else if (transferAmount && transferTo.current){
      setButtonLock(false);
    }else{
      setButtonLock(true)
    }
  },[transferAmount,transferTo, isAddNewMember, isMemberExisting]);

  if(!membership) return <></>;

  return(
    <div className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`}>
      <div className={`${window.innerWidth > 767 ? "modal-container transfer-membership-modal flex-item" : "w-full h-full"}`}>
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M25.7148 11.7861H5.71484L12.5898 4.28613M5.71484 16.7861H25.7148L18.8398 24.2861" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item fs-18 font-weight-600 color-white m-l-5">Transfer Membership</p>
              </div>
              <div onClick={()=>props.toggleFitnessTestModal("transfer-membership")} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div className="w-full" style={{height:"90%", paddingBottom:"40px", overflowY:"auto"}}>
          <div style={{padding:"12px", position:"relative"}}>
            {/* <svg className="flex-item" style={{position:"absolute", top:0}} width="100%" height="auto" viewBox="0 0 468 239" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="467" height="238" rx="11.5" fill="#EDEDED" stroke="#BABABA" stroke-dasharray="4 4"/>
            </svg> */}
            {
                window.innerWidth > 767 ? (
                  <div className="w-full" style={{border:"1px dashed #9a9a9a", borderRadius:"12px", background:"#ffffff"}}>
                    <div className="tf-header-container d-flex space-between flex-item">
                      <div className="flex-item">
                        <p className="flex-item">Membership Name</p>
                        <p className="flex-item fs-16 color-dark-blue font-weight-700">{membership?.membershipplans?.[0]?.name}</p>
                      </div>
                      <div className="flex-item" style={{textAlign:"right"}}>
                        <p className="flex-item">Transfer Membership</p>
                        <p className="flex-item fs-16 color-dark-back font-weight-700">{membership.membershipDisplayNumber}</p>
                      </div>
                    </div>
                    <div className="w-full" style={{padding:"12px"}}>
                      <div className="d-flex-wrap space-between">
                        <div className="flex-item d-flex space-between m-b-12" style={{width:"46%"}}>
                          <p className="flex-item">Duration</p>
                          <p className="flex-item font-weight-700">{membership.membershipplans[0].packages[0].duration} {membership.membershipplans[0].packages[0].durationType}'s</p>
                        </div>
                        <div className="flex-item d-flex space-between m-b-12" style={{width:"46%"}}>
                          <p className="flex-item">Total Sessions</p>
                          <p className="flex-item font-weight-700">{Number(membership.sessions) + Number(membership?.add_on_days || 0)}</p>
                        </div>
                        <div className="flex-item d-flex space-between m-b-12" style={{width:"46%"}}>
                          <p className="flex-item">Start Date</p>
                          <p className="flex-item font-weight-700">{membership.starts_at_string}</p>
                        </div>
                        <div className="flex-item d-flex space-between m-b-12" style={{width:"46%"}}>
                          <p className="flex-item">Sessions Transferred</p>
                          <p className="flex-item font-weight-700">{(Number(membership.sessions) + Number(membership?.add_on_days || 0)) - Number(membership.completed_sessions || 0)}</p>
                        </div>
                        <div className="flex-item d-flex space-between m-b-12" style={{width:"46%"}}>
                          <p className="flex-item">End Date</p>
                          <p className="flex-item font-weight-700">{membership.ends_at_string}</p>
                        </div>
                      </div>
                      <div className="flex-item m-t-12 m-b-12" style={{width:"100%", height:"1px", background:"#e0e0e0"}} />
                      <div className="d-flex">
                        {
                          membership.trainer.length && (
                            membership.trainer[0].profileID?(
                              <img style={{width:"40px", height:"40px", borderRadius:"100%"}} className="flex-item" src={`${client.config.API_URL}/image/file/${membership.trainer[0].profileID}/30/30/70?${Date.now()}`} />
                            ):(
                              <div className='flex-item d-flex' style={{width:"40px", height:"40px", borderRadius:"100%", backgroundColor: "#5d883c"}}>
                                <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${membership.trainer[0].name}`.trim()[0]}</p>
                              </div>
                            )
                          )
                        }
                        <div className="flex-item m-l-12">
                          <p className="flex-item font-weight-700 fs-16">{membership?.trainer?.[0]?.name}</p>
                          <p className="flex-item fs-12 color-grey-02">Assigned Trainer</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="w-full" style={{border:"1px solid #e0e0e0", borderRadius:"16px", background:"#ffffff", padding:"16px"}}>
                    <div className="d-flex w-full m-b-12">
                      <p className="flex-item" style={{width:"120px", flexShrink:0, color:"#6D6D6D"}}>Membership Name</p>
                    </div>
                    <p className="flex-item fs-17 color-dark-blue font-weight-700 m-b-16" style={{marginTop:"-16px"}}>{membership?.membershipplans?.[0]?.name}</p>

                    <div className="d-flex w-full m-b-12">
                      <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>Transfer Membership</p>
                      <p className="flex-item font-weight-700 color-dark-blue">{membership.membershipDisplayNumber}</p>
                    </div>
                    <div className="d-flex w-full m-b-12">
                      <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>Duration</p>
                      <p className="flex-item font-weight-700 color-dark-blue">{membership.membershipplans[0].packages[0].duration} {membership.membershipplans[0].packages[0].durationType}'s</p>
                    </div>
                    <div className="d-flex w-full m-b-12">
                      <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>Total Sessions</p>
                      <p className="flex-item font-weight-700 color-dark-blue">{Number(membership.sessions) + Number(membership?.add_on_days || 0)}</p>
                    </div>
                    <div className="d-flex w-full m-b-12">
                      <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>Start Date</p>
                      <p className="flex-item font-weight-700 color-dark-blue">{membership.starts_at_string}</p>
                    </div>
                    <div className="d-flex w-full m-b-12">
                      <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>End Date</p>
                      <p className="flex-item font-weight-700 color-dark-blue">{membership.ends_at_string}</p>
                    </div>
                    <div className="d-flex w-full">
                      <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>Sessions Transferred</p>
                      <p className="flex-item font-weight-700 color-dark-blue">{(Number(membership.sessions) + Number(membership?.add_on_days || 0)) - Number(membership.completed_sessions || 0)}</p>
                    </div>

                    <div className="flex-item m-t-16 m-b-16" style={{width:"100%", height:"1px", background:"#e0e0e0"}} />

                    <div className="d-flex">
                      {
                        membership.trainer.length && (
                          membership.trainer[0].profileID?(
                            <img style={{width:"40px", height:"40px", borderRadius:"100%"}} className="flex-item" src={`${client.config.API_URL}/image/file/${membership.trainer[0].profileID}/30/30/70?${Date.now()}`} />
                          ):(
                            <div className='flex-item d-flex' style={{width:"40px", height:"40px", borderRadius:"100%", backgroundColor: "#5d883c"}}>
                              <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${membership.trainer[0].name}`.trim()[0]}</p>
                            </div>
                          )
                        )
                      }
                      <div className="flex-item m-l-12">
                        <p className="flex-item font-weight-700 fs-16">{membership?.trainer?.[0]?.name}</p>
                        <p className="flex-item fs-12 color-grey-02">Assigned Trainer</p>
                      </div>
                    </div>
                  </div>
                )
              }
            <p className="fs-16 font-weight-700 color-dark-blue m-t-16 m-b-8">Transfer To</p>
            <div className="d-flex space-between" style={window.innerWidth > 767 ? {} : {flexDirection:"column", alignItems:"center"}}>
              {
                isAddNewMember ? [
                    <div className="d-flex space-between" style={window.innerWidth > 767 ? {width:"76%"} : {flexDirection:"column", width:"100%"}}>
                      <div onClick={toggleInputFields('member-name')} className={`${currentElementId == "member-name" || newMember.name ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "member-name" || newMember.name ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "48.5%" : "100%", marginBottom: window.innerWidth > 767 ? "0" : "12px" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "member-name" || newMember.name ? "10px" : "14px", color: currentElementId == "member-name" || newMember.name ? "var(--darkBlue)" : "", transition: "180ms" }}>Member Name <span className="color-red font-weight-700">*</span></p>
                        </div>
                        <input id="member-name" onChange={handleChange('member-name')} placeholder='Enter Name' value={newMember.name} className={`${currentElementId == "member-name" || newMember.name ? "active-input-field" : "inactive-input-field"}`} type="text" />
                      </div>
                      <div onClick={toggleInputFields('member-phone')} className={`${currentElementId == "member-phone" || newMember.phone ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "member-phone" || newMember.phone ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "48.5%" : "100%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "member-phone" || newMember.phone ? "10px" : "14px", color: currentElementId == "member-phone" || newMember.phone ? "var(--darkBlue)" : "", transition: "180ms" }}>Member Phone <span className="color-red font-weight-700">*</span></p>
                        </div>
                        <input id="member-phone" onChange={handleChange('member-phone')} placeholder='+91 00000-00000' value={newMember.phone} className={`${currentElementId == "member-phone" || newMember.phone ? "active-input-field" : "inactive-input-field"}`} type="text" />
                      </div>
                    </div>,
                    !isMemberExisting ? (
                      <div onClick={()=>toggleAddNewMember()} className="w-full d-flex bg-red cursor-pointer" style={{width:"50px",height:"50px", borderRadius:"12px", marginTop: window.innerWidth > 767 ? "0" : "12px"}}> 
                        <svg className="flex-item margin-auto" width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 14C5.046 14 3.39067 13.3223 2.034 11.967C0.678 10.611 0 8.95634 0 7.00301C0 5.04967 0.678 3.39434 2.034 2.03701C3.39 0.679674 5.04533 0.000673516 7 6.84931e-06C8.18867 6.84931e-06 9.30167 0.28234 10.339 0.847007C11.3757 1.41167 12.2113 2.20001 12.846 3.21201V0.500007C12.846 0.358007 12.894 0.23934 12.99 0.144007C13.086 0.0486736 13.205 0.000673516 13.347 6.84931e-06C13.489 -0.000659817 13.6077 0.0473402 13.703 0.144007C13.7983 0.240674 13.846 0.35934 13.846 0.500007V4.42301C13.846 4.65167 13.7687 4.84367 13.614 4.99901C13.4593 5.15434 13.2673 5.23167 13.038 5.23101H9.115C8.97367 5.23101 8.855 5.18301 8.759 5.08701C8.663 4.99101 8.615 4.87201 8.615 4.73001C8.615 4.58801 8.663 4.46934 8.759 4.37401C8.855 4.27867 8.97367 4.23101 9.115 4.23101H12.315C11.795 3.23367 11.0627 2.44567 10.118 1.86701C9.17467 1.28901 8.13533 1.00001 7 1.00001C5.33333 1.00001 3.91667 1.58334 2.75 2.75001C1.58333 3.91667 1 5.33334 1 7.00001C1 8.66667 1.58333 10.0833 2.75 11.25C3.91667 12.4167 5.33333 13 7 13C8.19133 13 9.28167 12.6773 10.271 12.032C11.261 11.386 11.995 10.5283 12.473 9.45901C12.5297 9.32834 12.621 9.23667 12.747 9.18401C12.8737 9.13067 13.003 9.12634 13.135 9.17101C13.2757 9.21567 13.369 9.30734 13.415 9.44601C13.461 9.58467 13.456 9.71934 13.4 9.85001C12.8447 11.1067 11.9913 12.1123 10.84 12.867C9.68867 13.6217 8.40867 13.9993 7 14Z" fill="#ffffff"/>
                        </svg>
                      </div>
                    ) : [
                      <div className="d-flex" style={{marginTop: window.innerWidth > 767 ? "0" : "12px", width: window.innerWidth > 767 ? "auto" : "100%", justifyContent: window.innerWidth > 767 ? "flex-start" : "center"}}>
                        <div onClick={()=>toggleAddNewMember()} className="w-full d-flex bg-red cursor-pointer m-r-12" style={{width:"50px",height:"50px", borderRadius:"12px"}}> 
                          <svg className="flex-item margin-auto" width="16" height="16" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 14L14 1M14 14L1 1" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                        <div onClick={()=>handleCheckExistingMember()} className="w-full d-flex bg-green cursor-pointer" style={{width:"50px",height:"50px", borderRadius:"12px"}}> 
                          <svg className="flex-item margin-auto" width="16" height="16" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 6.08696L4.48387 10L13 1" stroke="white" stroke-width="2" stroke-linecap="round"/>
                          </svg>
                        </div>
                      </div>
                    ]
                  ] : [
                  <div onClick={toggleInputFields('transfer-to')} className={`${currentElementId == "transfer-to" || transferTo.current ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "transfer-to" || transferTo.current) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "60%" : "100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "transfer-to" || transferTo.current) ? "10px" : "14px", color: (currentElementId == "transfer-to" || transferTo.current) ? "var(--darkBlue)" : "", transition: "180ms" }}>Select Member</p>
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" style={{ transform: isTransferToListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                    <input value={transferTo.current?.user?.[0]?.name} className={`${currentElementId == "transfer-to" || transferTo.current ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Transfer to Member" style={{ textTransform:'capitalize' }} readOnly />
                    {
                      isTransferToListOpen && (
                        <div className="global-input-field-arrow-dropdown" style={{maxHeight:"300px", overflowY:"scroll", background:"#f5f5f5"}} onScroll={handleMemberScroll}>
                          {/* <input onChange={_.debounce(handleSearch,700)}  type="text" Placeholder="Search Member by phone or " /> */}
                          <div onClick={(e)=>e.stopPropagation()} className="w-full" style={{padding:"12px"}}>
                            <SearchFilter searchType={"By Member Name or Phone No."} isSearchEnabled={true} searchingData={handleSearchingData} isFilterEnabled={false} count={Total}  />
                          </div>
                          {
                            Members.map(data => {
                              if(data.user?.[0]?.name){
                                return(
                                  <div onClick={()=>handleSelectTransferTo(data)} className="global-input-field-arrow-dropdown-item d-flex" style={{borderBottom:"1px solid #e0e0e0"}}>
                                    {
                                      (data.user && data.user.length > 0) && (
                                        (data.user[0].profileID) ?
                                          <div className='tr-profile-image d-flex flex-item m-r-8'>
                                            <img id="gym-ImgWrapper" src={`${client.config.API_URL}/image/file/${data.user[0].profileID}/30/30/70?${Date.now()}`} loading='lazy' className="gym-logo" />
                                          </div>
                                          : <div className="tr-profile-image d-flex flex-item m-r-8" style={{
                                            backgroundColor: "#5d883c",
                                            width:"40px",
                                            height:"40px"
                                          }}>
                                            <p className='flex-item' style={{
                                              color: "#ffffff",
                                              margin: "0 auto",
                                              fontSize: 14,
                                              textTransform:"uppercase"
                                            }}>{`${data.user[0].name}`.trim()[0]}</p>
                                          </div>
                                      )
                                    }
                                    <div className="flex-item">
                                      <p className="flex-item" style={{fontSize:"15px", fontWeight:"600"}}>{data.user?.[0]?.name ? data.user[0].name : "--"}</p>
                                      <span className="flex-item" style={{fontSize:"12px"}}>+91 {data.user?.[0]?.phone ? data.user[0].phone : "--"}</span>
                                    </div>
                                  </div>
                                )
                              }
                            })
                          }
                          {isMembersSpinnerLoader && <div className="loader-5 center"><span></span></div>}
                        </div>
                      )
                    }
                  </div>,
                  <p className="flex-item fs-16 color-dark-blue font-weight-700" style={window.innerWidth > 767 ? {} : {margin:"12px 0"}}>OR</p>,
                  <div onClick={()=>toggleAddNewMember()} className="w-full d-flex bg-white cursor-pointer" style={{width: window.innerWidth > 767 ? "auto" : "100%",height:"50px", borderRadius:"12px", border:"1px solid #9a9a9a"}}> 
                    <p className="flex-item font-weight-600 margin-auto" style={{whiteSpace:"nowrap", padding:"0 16px"}}>Add New Member</p>
                  </div>
                ]
              }
            </div>
            {isMemberExistingNote && <p className="color-red fs-12 m-t-12">User already exists with this phone no.! Try Another</p>}
            <div className="m-b-20" />
            {
              (isAddNewMember == false || (isAddNewMember == true && !isMemberExisting)) && (
                <div className="w-full">
                
                  <div onClick={toggleInputFields('transfer-amount')} className={`${currentElementId == "transfer-amount" || transferAmount ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: currentElementId == "transfer-amount" || transferAmount ? "1px solid var(--darkBlue)" : "", width:"100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "transfer-amount" || transferAmount ? "10px" : "14px", color: currentElementId == "transfer-amount" || transferAmount ? "var(--darkBlue)" : "", transition: "180ms" }}>Transfer Amount</p>
                    </div>
                    <input onChange={handleChange('transferAmount')} id="end-date" placeholder='Enter Amount' value={transferAmount} className={`${currentElementId == "transfer-amount" || transferAmount ? "active-input-field" : "inactive-input-field"}`} type="number" />
                  </div>
                  <div className="d-flex m-b-14 m-b-20">
                    <div className="flex-item d-flex">
                      <input onClick={applyInclusive} checked={taxType == "inclusive-tax"} className="flex-item m-r-8" type="checkbox" style={{width:"20px", height:"20px"}} />
                      <p className="flex-item font-weight-700 color-dark-blue fs-16">Inclusive Taxes</p>
                    </div>
                    <div className="flex-item d-flex m-l-20">
                      <input onClick={applyTaxes} checked={taxType == "additional-tax"} className="flex-item m-r-8" type="checkbox" style={{width:"20px", height:"20px"}} />
                      <p className="flex-item font-weight-700 color-dark-blue fs-16">Additional Taxes</p>
                    </div>
                  </div>
                  {taxType && <div className="w-full d-flex-wrap">
                    {
                      billingInfo.taxBreakup.map(tax=>{
                        return (
                          <div className="d-flex space-between flex-item m-b-16 m-r-40" style={{width:"34%"}}>
                            <p className="flex-item">{tax.name} ( {tax.value} % )</p>
                            <p className="flex-item font-weight-700">₹ {tax.amount}</p>
                          </div>
                        )
                      })
                    }
                    {/* <div className="d-flex space-between flex-item m-b-16 m-r-40" style={{width:"34%"}}>
                      <p className="flex-item">CGST (5.0%)</p>
                      <p className="flex-item font-weight-700">₹ 0.0</p>
                    </div>
                    <div className="d-flex space-between flex-item m-b-16" style={{width:"34%"}}>
                      <p className="flex-item">SGST (5.0%)</p>
                      <p className="flex-item font-weight-700">₹ 0.0</p>
                    </div>
                    <div className="d-flex space-between flex-item m-b-16" style={{width:"34%"}}>
                      <p className="flex-item">Subtotal</p>
                      <p className="flex-item font-weight-700">₹ 0.0</p>
                    </div> */}
                  </div>}
                  <div className="d-flex space-between">
                    <div onClick={toggleInputFields('surcharges')} className={`${currentElementId == "surcharges" || Surcharges ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "surcharges" || Surcharges ? "1px solid var(--darkBlue)" : "", width:"40%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "surcharges" || Surcharges ? "10px" : "14px", color: currentElementId == "surcharges" || Surcharges ? "var(--darkBlue)" : "", transition: "180ms" }}>Surcharges (%)</p>
                      </div>
                      <input id="surcharges" onChange={handleChange('Surcharges')} placeholder='Enter surcharges' value={Surcharges} className={`${currentElementId == "surcharges" || Surcharges ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div className="" style={{justifyContent:"center", textAlign:"center", background:"var(--red)", width:"58%", borderRadius:"8px", height:"50px"}}>
                      <p className="flex-item color-white m-t-4 fs-12">Total Payable Amount</p>
                      <p className="flex-item color-white font-weight-600 fs-18">₹ {billingInfo.payableAmount}</p>
                    </div>
                  </div>

                  <p className="color-dark-blue font-weight-600 fs-14 m-t-20">Payment Mode</p>
                  <div className="d-flex-wrap m-t-8">
                    <div onClick={handlePaymentMode("online")} className="flex-item d-flex m-r-20">
                      <input className="flex-item m-r-8" type="radio"  checked={invoiceDetails.paymentMode == "online"} style={{width:"20px", height:"20px"}}/>
                      <p className="flex-item font-weight-600 fs-16">Online</p>
                    </div>
                    <div onClick={handlePaymentMode("wallet")} className="flex-item d-flex m-r-20">
                      <input checked={invoiceDetails.paymentMode == "wallet"} className="flex-item m-r-8" type="radio"  style={{width:"20px", height:"20px"}}/>
                      <p className="flex-item font-weight-600 fs-16">Wallet</p>
                    </div>
                    <div onClick={handlePaymentMode("cheque")} className="flex-item d-flex m-r-20">
                      <input checked={invoiceDetails.paymentMode == "cheque"} className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} />
                      <p className="flex-item font-weight-600 fs-16">Cheque</p>
                    </div>
                    <div onClick={handlePaymentMode("cash")} className="flex-item d-flex m-r-20">
                      <input checked={invoiceDetails.paymentMode == "cash"} className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}}/>
                      <p className="flex-item font-weight-600 fs-16">Cash</p>
                    </div>
                    <div onClick={handlePaymentMode("other")} className="flex-item d-flex">
                      <input checked={invoiceDetails.paymentMode == "other"} className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}}/>
                      <p className="flex-item font-weight-600 fs-16">Other</p>
                    </div>
                  </div>

              
                  <div className="m-t-16 p-t-4 p-b-4">

                  {
                    (invoiceDetails.paymentMode == "online" || invoiceDetails.paymentMode == "wallet") && (
                      <div className="w-full">
                        <div onClick={toggleInputFields('paymentSource')} className={`${currentElementId == "paymentSource" || invoiceDetails.paymentSource ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width:"100%" }}>
                          {
                            isMobile ? (
                              <div className='d-flex w-full space-between'>
                                <div className='flex-item'>
                                  <div className="flex-item d-flex">
                                    <svg className="flex-item m-r-4" width={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "14" : "24"} height={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                    </svg>
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "10px" : "16px", lineHeight: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "10px" : "16px", color: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment is done via</p>
                                  </div>

                                  <input readOnly id="paymentSource"
                                        value={invoiceDetails.paymentSource || ""}
                                        type="text"
                                        className={`${(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "active-input-field" : "inactive-input-field"}`}
                                        placeholder="Payment is done via"
                                        style={{ marginTop: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "6px" : "" }} />
                                </div>

                                <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                                  <svg className="flex-item" style={{ transform: currentElementId == "paymentSource" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                                  </svg>
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="flex-item d-flex" style={{marginTop: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "4px" : ""}}>
                                  <svg className="flex-item m-r-4" width={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "14" : "24"} height={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                  </svg>
                                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "10px" : "16px", lineHeight: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "10px" : "16px", color: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment is done via</p>
                                </div>
                                <div className='input-field-arrow-dropdown' style={{ margin: "18px 12px 4px 0", transition: "180ms" }}>
                                  <svg className="flex-item" style={{ transform: currentElementId == "paymentSource" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                  </svg>
                                </div>
                                <p id="paymentSource" className={`flex-item fs-16 m-t-24 ${(currentElementId == "paymentSource") ? "active-input-field color-grey-04" : invoiceDetails.paymentSource ? "active-input-field" : "inactive-input-field"}`}>{invoiceDetails.paymentSource ? invoiceDetails.paymentSource : "Payment is done via"}</p>
                              </>
                            )
                          }

                          {
                            currentElementId == "paymentSource" && (
                              <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : !isMobile && invoiceDetails.paymentSource ? "70px" : undefined, padding: "0"}}>
                                {
                                  invoiceDetails.paymentMode == "online" && (
                                    <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                      {
                                        paymentSources.online.map((data, index) => {
                                          return (
                                            <div onClick={()=>handleSelectPaymentSource(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                              <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                  )
                                }

                                {
                                  invoiceDetails.paymentMode == "wallet" && (
                                    <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                      {
                                        paymentSources.wallet.map((data, index) => {
                                          return (
                                            <div onClick={()=>handleSelectPaymentSource(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                              <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                  )
                                }
                              </div>
                            )
                          }
                        </div>
                      </div>
                    )  
                  }

                  {
                    invoiceDetails.paymentMode == "cheque" && (
                      <div className="w-full">
                        <div onClick={toggleInputFields('cheque-number')} className={`${currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "1px solid var(--darkBlue)" : "" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "cheque-number" || invoiceDetails.chequeNumber ? "10px" : "14px", color: currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Cheque Number</p>
                        </div>
                        <input id="cheque-number" value={invoiceDetails.chequeNumber} placeholder="Enter Cheque Number" onChange={handleChange("chequeNumber")} className={`${currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                      </div>
                      </div>
                    ) 
                  }

                  {
                    (invoiceDetails.paymentSource == "NEFT" || invoiceDetails.paymentSource == "RTGS" || invoiceDetails.paymentSource == "IMPS" ) && (
                      <div className="w-full">
                        <div onClick={toggleInputFields('bank-name')} className={`${currentElementId == "bank-name" || invoiceDetails.bankName ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "bank-name" || invoiceDetails.bankName ? "1px solid var(--darkBlue)" : "" }}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "bank-name" || invoiceDetails.bankName ? "10px" : "14px", color: currentElementId == "bank-name" || invoiceDetails.bankName ? "var(--darkBlue)" : "", transition: "180ms" }}>Bank Name</p>
                          </div>
                          <input id="bank-name" value={invoiceDetails.bankName} placeholder="Enter Bank Name" onChange={handleChange("bankName")} className={`${currentElementId == "bank-name" || invoiceDetails.bankName ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                        </div>
                      </div>
                    )
                  }

                  {
                    (invoiceDetails.paymentSource == "Credit Card" || invoiceDetails.paymentSource == "Debit Card") && (
                      <div onClick={toggleInputFields("card-type")} className={`${currentElementId == "card-type" || invoiceDetails.cardType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "card-type" || invoiceDetails.cardType) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width:"100%" }}>
                        {
                          isMobile ? (
                            <div className='d-flex w-full space-between'>
                              <div className='flex-item'>
                                <div className="flex-item d-flex">
                                  <svg className="flex-item m-r-4" width={(currentElementId == "card-type" || invoiceDetails.cardType) ? "14" : "24"} height={(currentElementId == "card-type" || invoiceDetails.cardType) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "card-type" || invoiceDetails.cardType) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                  </svg>
                                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "card-type" || invoiceDetails.cardType) ? "10px" : "16px", lineHeight: (currentElementId == "card-type" || invoiceDetails.cardType) ? "10px" : "16px", color: (currentElementId == "card-type" || invoiceDetails.cardType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Card Type</p>
                                </div>

                                <input readOnly id="card-type"
                                      value={invoiceDetails.cardType || ""}
                                      type="text"
                                      className={`${(currentElementId == "card-type" || invoiceDetails.cardType) ? "active-input-field" : "inactive-input-field"}`}
                                      placeholder="Select Card Type"
                                      style={{ marginTop: (currentElementId == "card-type" || invoiceDetails.cardType) ? "6px" : "" }} />
                              </div>

                              <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                                <svg className="flex-item" style={{ transform: currentElementId == "card-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                                </svg>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="flex-item d-flex" style={{marginTop: (currentElementId == "card-type" || invoiceDetails.cardType) ? "4px" : ""}}>
                                <svg className="flex-item m-r-4" width={(currentElementId == "card-type" || invoiceDetails.cardType) ? "14" : "24"} height={(currentElementId == "card-type" || invoiceDetails.cardType) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "card-type" || invoiceDetails.cardType) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                </svg>
                                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "card-type" || invoiceDetails.cardType) ? "10px" : "16px", lineHeight: (currentElementId == "card-type" || invoiceDetails.cardType) ? "10px" : "16px", color: (currentElementId == "card-type" || invoiceDetails.cardType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Card Type</p>
                              </div>
                              <div className='input-field-arrow-dropdown' style={{ margin: "18px 12px 4px 0", transition: "180ms" }}>
                                <svg className="flex-item" style={{ transform: currentElementId == "card-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                </svg>
                              </div>
                              <p id="card-type" className={`flex-item fs-16 m-t-24 ${(currentElementId == "card-type") ? "active-input-field color-grey-04" : invoiceDetails.cardType ? "active-input-field" : "inactive-input-field"}`}>{invoiceDetails.cardType ? invoiceDetails.cardType : "Select Card Type"}</p>
                            </>
                          )
                        }

                        {
                          currentElementId == "card-type" && (
                            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : !isMobile && invoiceDetails.cardType ? "70px" : undefined}}>
                              <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                {
                                  cardTypes.map((data, index) => {
                                    return (
                                      <div onClick={()=>handleSelectCard(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                        <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>
                          )
                        }
                      </div>
                    )
                  }

                  {
                    (invoiceDetails.paymentSource == "Credit Card" || invoiceDetails.paymentSource == "Debit Card") && (
                      <div onClick={toggleInputFields('approved-code')} className={`${currentElementId == "approved-code" || invoiceDetails.approvedCode ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "approved-code" || invoiceDetails.approvedCode ? "1px solid var(--darkBlue)" : "" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "approved-code" || invoiceDetails.approvedCode ? "10px" : "14px", color: currentElementId == "approved-code" || invoiceDetails.approvedCode ? "var(--darkBlue)" : "", transition: "180ms" }}>Approved Code</p>
                        </div>
                        <input id="approved-code" value={invoiceDetails.approvedCode} placeholder="Enter Approved Code" onChange={handleChange("approvedCode")} className={`${currentElementId == "approved-code" || invoiceDetails.approvedCode ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                      </div>
                    )
                  }

                  {
                    (invoiceDetails.paymentSource == "UPI") && (
                      <div onClick={toggleInputFields('upi-id')} className={`${currentElementId == "upi-id" || invoiceDetails.upiId ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "upi-id" || invoiceDetails.upiId ? "1px solid var(--darkBlue)" : "" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "upi-id" || invoiceDetails.upiId ? "10px" : "14px", color: currentElementId == "upi-id" || invoiceDetails.upiId ? "var(--darkBlue)" : "", transition: "180ms" }}>Aadhaar No./Mobile No.</p>
                        </div>
                        <input id="upi-id" value={invoiceDetails.upiId} placeholder="Enter Aadhaar or Mobile No. or UPI ID" onChange={handleChange("upiId")} className={`${currentElementId == "upi-id" || invoiceDetails.upiId ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                      </div>
                    )
                  }

                  {
                    invoiceDetails.paymentSource == "Paytm" || invoiceDetails.paymentSource == "PhonePe" || invoiceDetails.paymentSource == "Google Pay" || invoiceDetails.paymentSource == "Amazon Pay" && (
                      <div onClick={toggleInputFields('payment-number')} className={`${currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "1px solid var(--darkBlue)" : "" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "payment-number" || invoiceDetails.paymentNumber ? "10px" : "14px", color: currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment mobile number</p>
                        </div>
                        <div className={`${currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "active-input-field" : "inactive-input-field"} d-flex m-t-20`}>
                          <input className="flex-item" id="payment-number" value={invoiceDetails.paymentNumber} placeholder="Enter payment mobile number" onChange={handleChange("paymentNumber")} style={{width:"100%"}} type="text" />
                        </div>
                      </div>
                    )
                  }

                  {
                    (invoiceDetails.paymentSource == "NEFT" || invoiceDetails.paymentSource == "RTGS" || invoiceDetails.paymentSource == "IMPS" || invoiceDetails.paymentSource == "UPI" || invoiceDetails.paymentSource == "Juice" || invoiceDetails.paymentSource == "Paytm" || invoiceDetails.paymentSource == "PhonePe" || invoiceDetails.paymentSource == "Google Pay" || invoiceDetails.paymentSource == "Amazon Pay") && (
                      <div onClick={toggleInputFields('transaction-id')} className={`${currentElementId == "transaction-id" || invoiceDetails.transactionID ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "transaction-id" || invoiceDetails.transactionID ? "1px solid var(--darkBlue)" : "" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "transaction-id" || invoiceDetails.transactionID ? "10px" : "14px", color: currentElementId == "transaction-id" || invoiceDetails.transactionID ? "var(--darkBlue)" : "", transition: "180ms" }}>Transaction ID</p>
                        </div>
                        <input id="transaction-id" value={invoiceDetails.transactionID} placeholder="Enter Transaction ID" onChange={handleChange("transactionID")} className={`${currentElementId == "transaction-id" || invoiceDetails.transactionID ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                      </div>
                    )
                  }


                  {
                    invoiceDetails.paymentMode == "other" && (
                      <div onClick={toggleInputFields('comment')} className={`${currentElementId == "comment" || invoiceDetails.comment ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "comment" || invoiceDetails.comment ? "1px solid var(--darkBlue)" : "" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "comment" || invoiceDetails.comment ? "10px" : "14px", color: currentElementId == "comment" || invoiceDetails.comment ? "var(--darkBlue)" : "", transition: "180ms" }}>Comment *</p>
                        </div>
                        <input id="comment" value={invoiceDetails.comment} placeholder="Enter Comment" onChange={handleChange("comment")} className={`${currentElementId == "comment" || invoiceDetails.comment ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                      </div>
                    )
                  }
                  </div>
                  
                  <div className="d-flex flex-item m-t-12 m-b-12" style={{borderBottom:"1px dashed #e0e0e0" }} />
                  <div onClick={toggleInputFields('remark')} className={`${currentElementId == "remark" || remark ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-40`} style={{ border: currentElementId == "remark" || remark ? "1px solid var(--darkBlue)" : "", width:"100%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "remark" || remark ? "10px" : "14px", color: currentElementId == "remark" || remark ? "var(--darkBlue)" : "", transition: "180ms" }}>Remark</p>
                    </div>
                    <input id="remark" onChange={handleChange('remark')} placeholder='Enter Your Remarks Here' value={remark} className={`${currentElementId == "remark" || remark ? "active-input-field" : "inactive-input-field"}`} type="text" />
                  </div>
                </div>
              )
            }
          </div>
        </div>

        <div className="bottom-action-button">
          <div className='d-flex space-between' style={{gap: window.innerWidth > 767 ? "0" : "12px"}}>
            <div onClick={()=>props.toggleFitnessTestModal("transfer-membership")} className={`member-button-global btn-center d-flex member-button-global-inactive`} style={{ width: window.innerWidth > 767 ? "48%" : "calc(50% - 6px)", height:"40px", borderRadius:"20px" }}>
              <p className="flex-item" style={{fontSize:"16px", fontWeight:"600"}}>Cancel</p>
            </div>
            <div onClick={isButtonLock?null:TransferMembership} className={`member-button-global ${isButtonLock ? "member-button-global-inactive" : "global-blue-button-controller-active"} btn-center d-flex`} style={{ width: window.innerWidth > 767 ? "48%" : "calc(50% - 6px)", height:"40px", borderRadius:"20px" ,pointerEvents:isButtonLock?'none':'auto'}}>
              <p className="flex-item" style={{fontSize:"16px", fontWeight:"600"}}>Transfer</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransferMembershipModal;